import api from './api';

const getAll = () => api.get('/tenants');
const getById = (id) => api.get(`/tenants/${id}`);
const create = (formData) => api.post('/tenants', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
const update = (id, formData) => api.put(`/tenants/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
const remove = (id) => api.delete(`/tenants/${id}`);
const downloadFile = (filename) => api.get(`/tenants/file/${encodeURIComponent(filename)}`, { responseType: 'blob' });

export const tenantsAPI = { getAll, getById, create, update, remove, downloadFile };
